import { Button, Stack, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import Dialog from '../Common/Dialog/Dialog';
import DialogActions from '../Common/Dialog/DialogActions';
import DialogContent from '../Common/Dialog/DialogContent';
import DialogTitle from '../Common/Dialog/DialogTitle';
import { useAppSelector } from '../Common/_hooks/useAppSelector';
import AuthForm from './AuthForm';

export default function SessionMismatchDialog() {
  const [t] = useTranslation('auth');
  const location = useLocation();

  const opened = useAppSelector(state => state.get('Auth').get('sessionMismatchDialogOpened'));
  const reason = useAppSelector(state => state.get('Auth').get('sessionMismatchReason'));

  const onReload = useCallback(() => {
    window.location.reload();
  }, []);

  const title = useMemo(() => {
    if (reason === 'different-user') {
      return t('Account changed');
    }

    return t('Your session expired');
  }, [reason, t]);

  const message = useMemo(() => {
    if (reason === 'different-user') {
      return t('This page is using a different account than your current browser session. Sign in again, or reload the page to continue with the current account.');
    }

    return t('You have been logged out. Please sign in again to continue.');
  }, [reason, t]);

  return <Dialog
    open={opened}
    disableEscapeKeyDown
    maxWidth="md"
    fullWidth
    ornaments="shapes-3"
  >
    <DialogTitle
      sx={{
        textAlign: {
          xs: 'left',
          sm: 'center',
        },
        fontSize: '3.25rem',
      }}
    >{title}</DialogTitle>

    <DialogContent>
      <Stack spacing={3}>
        <Typography
          variant="body1"
          sx={{
            textAlign: {
              xs: 'left',
              sm: 'center',
            },
          }}
        >{message}</Typography>

        <AuthForm
          signup={false}
          redirect={location.pathname + location.search}
          hideSignupPrompt
        />
      </Stack>
    </DialogContent>

    {reason === 'different-user' ? <DialogActions>
      <Button
        color="secondary"
        variant="text"
        onClick={onReload}
      >{t('Reload page')}</Button>
    </DialogActions> : null}
  </Dialog>;
}
